import { useEffect, useState } from "react";
import { WelcomeModal } from "../../Pages/Auth/signup/signup.styles"
import Button from "../button/button.component"
import Image from "../image/image.component";

const TradeModal = ({open, onClose}) => {
    const [openTrade, setOpenTrade] = useState(false);
    const handleOpenTrade = () => setOpenTrade(true);
    const handleCloseTrade = () => setOpenTrade(false);

    const handleClose = () => {
        onClose.call(this);
    } 

    useEffect(() => {
      if(open) {
            handleOpenTrade();

        }
        else {
            handleCloseTrade();
        }
    }, [open]);

    return (
        <WelcomeModal open={openTrade} onClose={() => handleClose()}>
            <div className="title">
                <Image src={'logo.png'} alt={'Music Bull'} width={150} />
                <h2 >Trading</h2>
            </div>
            <div style={{textAlign: "center"}}>
                Trading starts soon! The first symbol will be<br/> 
                available once our initial auction is complete.<br/>
                Stay tuned to be part of this music investment<br/> 
                journey!

            </div>
            <div className="button-container">
                <Button color="blue" onClick={() => handleClose()}>Close</Button>
            </div>
        </WelcomeModal>
    )
}

export default TradeModal;